/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import AlgorithmConfigurationDirective from './algorithm-configuration.directive';

export default angular.module('tektelic.algorithmConfiguration', [])
    .directive('tkAlgorithmConfiguration', AlgorithmConfigurationDirective)
    .name;



// WEBPACK FOOTER //
// ./src/app/algorithm-configuration/index.js